import NameCellWithImage, { ChipCell } from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { MRT_ColumnDef } from 'material-react-table';
import { useTranslation } from 'react-i18next';
import { PRODUCT_CATEGORY_STATUS_COLOR, useProductCategoryStatus } from './status';
import { useMemo } from 'react';
import { ToolTip } from 'components/controls';

export type ProductCategoriesColumns = {
    id: string;
    name: string;
    isActive: string;
};

export const useProductCategoryTableColumns = (): MRT_ColumnDef<ProductCategoriesColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();
    const statuses = useProductCategoryStatus();

    return useMemo(
        () => [
            {
                accessorKey: 'name',
                header: t('TABLE_HEADERS.NAME'),
                enableColumnActions: false,
                Cell: ({ cell }) => {
                    const path = `${baseWorkspaceUrl}/productCategory/${cell.row.original.id}`;
                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['name'].length < 30}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage
                                cell={cell}
                                defaultImage={'https://cdn-icons-png.freepik.com/512/7997/7997145.png'}
                                isLink
                                path={path}
                                target="_self"
                            />
                        </ToolTip>
                    );
                },
                size: 300,
            },
            {
                accessorKey: 'isActive',
                header: t('TABLE_HEADERS.STATUS'),
                filterVariant: 'autocomplete',
                enableSorting: false,
                enableColumnActions: false,
                size: 150,
                Cell: ({ cell }) => {
                    const status = cell.getValue() ? statuses.ACTIVE : statuses.INACTIVE;

                    return (
                        <ChipCell
                            value={cell.getValue<string>() ? 'ACTIVE' : 'INACTIVE'}
                            label={status}
                            statusColorMap={PRODUCT_CATEGORY_STATUS_COLOR}
                        />
                    );
                },
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
        ],
        [t, baseWorkspaceUrl, statuses],
    );
};
